module.exports = __webpack_public_path__ + "media/images/undraw_synchronize_re_4irq 1-00b4f16af0073ffdc94f041964c64a56.png";